module.exports = __webpack_public_path__ + "img/abm.37bd018a.png";